import { defineComponent as _defineComponent } from 'vue'
import CountUp from "vue-countup-v3";

interface Props {
    value: number;
    delay: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'countup',
  props: {
    value: { type: Number, required: true },
    delay: { type: Number, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const options = {
    enableScrollSpy: true,
    scrollSpyOnce: true,
    scrollSpyDelay: props.delay,
    separator: ".",
};

const __returned__ = { props, options, get CountUp() { return CountUp } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})